import { render, staticRenderFns } from "./UserDeclaratieDefaults.vue?vue&type=template&id=176d48b4"
import script from "./UserDeclaratieDefaults.vue?vue&type=script&lang=js"
export * from "./UserDeclaratieDefaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports